export default __webpack_public_path__ + "static/media/AvenirNextW04-Demi.f15b7099.woff2";